/** @typedef {import('../../../shared/SettingProvider/Component').State} Response */

import { SettingContext } from '../../../shared/SettingProvider/SettingProvider';
import { useContext } from 'react';

/** @returns {Response} */
export default function useSettings() {
	return useContext(SettingContext);
}
